import React from 'react';
import OneIcon from '../../../assets/ONE-icon.svg';
import AMPIcon from '../../../assets/amp_logo.svg';
import OneHubLogo from '../../../assets/OneHubLogo.png';
import RMPLogo from '../../../assets/RMPLogo.png';
import { translate } from '../../../shared/translations';
import GooglePlayStore from '../../../assets/Google-Play.svg';
import AppleAppStore from '../../../assets/Apple-App-Store.svg';
import AppetizeBackground from '../../../assets/ONE-bg.svg';
import LinkImage from '../../../components/LinkImage/LinkImage';
import Logo from '../../../components/Logo/Logo';
import {
    AMP,
    ONE,
    ONEHUB,
    RMP,
} from '../../../constants/constants';
import { Subhead1, Link } from '../../../shared/theme/styles';
import './Appetize.css';

export const Appetize = ({ appConfig }) => {
    const {
        headIconAlt = '',
        google = '',
        ios = '',
        appToUse = '',
    } = appConfig;

    const iconList = {
        [ONE]: OneIcon,
        [AMP]: AMPIcon,
        [ONEHUB]: OneHubLogo,
        [RMP]: RMPLogo,
    };

    const headerIcon = iconList[appToUse] || iconList[AMP];

    return (
        <div className="appetizePanel loginFormPanel">
            <Logo
                className={`${appToUse !== ONE && appToUse !== ONEHUB ? 'ampBackground' : 'movistaBackground'}`}
                url={AppetizeBackground}
                alt="movista-background"
            />
            <div className="loginContentWrapper">
                <div className="panelContent" style={Subhead1}>
                    <Logo className="ampIcon" url={headerIcon} alt={headIconAlt} />
                    {`${appToUse} ${translate('by_movista')}`}
                </div>
                <div className="panelContent">
                    <LinkImage
                        linkName="GooglePlayStore"
                        link={google}
                        image={GooglePlayStore}
                    />
                    <LinkImage
                        linkName="AppleAppStore"
                        link={ios}
                        image={AppleAppStore}
                    />
                </div>
                <a id="appetizeLink" style={Link} className="hyperlink-label panelContent panelLink" href={`/rep/mobile?app=${appToUse}`}>
                    {`${translate('launch')} ${appToUse}`}
                </a>
            </div>
        </div>
    );
};

export default Appetize;
